<template>
  <div class="container contact-main">
    <h1>CONTACT <span class="slim-text">US</span></h1>
    <p>
      Please fill out all your information and we will contact you as soon as possible.
      Thank you.
    </p>
    <ContactForm />
  </div>
</template>

<script>

import ContactForm from "../components/ContactForm";

export default {
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/main";
.slim-text{
  font-weight: 400;
}

h1{
  font-family: "Raleway", sans-serif;
  font-size: 5em;
  font-weight: 700;
}

p{
    font-family: "Raleway", sans-serif;
}
@media only screen and (max-width: 1000px) {
  h1 {
    font-size: 3em !important;
    margin: auto !important;
  }

}

</style>